import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { AccountApi } from '../../../../../generated/internalApi/api/AccountApi';
import { MortgagePasswordApi } from '../../../../../generated/internalApi/api/MortgagePasswordApi';

import {
  CommonResponse,
  PasswordResetTokenRequest,
  ChangePasswordRequest,
  ChangePasswordFromResetRequest
} from '../../models';

import { SessionService } from '../session/shared/session/session-service/session.service';

@Injectable()
export class AccountService {
  private authorization: string;

  constructor(
    private accountApi: AccountApi,
    private sessionService: SessionService) {

    this.authorization = sessionService.data.authData.token;
  }

  public sendForgotPasswordEmail(requestModel: PasswordResetTokenRequest): Observable<CommonResponse> {
    return this.accountApi.accountGetPasswordResetToken(
      requestModel,
      this.authorization
    ).catch(err => {
      console.error(err);
      return throwError(err);
    });
  }

  // used to update password when a GUID has been supplied- user need not enter old password
  public resetPassword(changePasswordModel: ChangePasswordFromResetRequest): Observable<CommonResponse> {
    return this.accountApi.accountResetPassword(
      changePasswordModel,
      this.authorization
    ).catch(err => {
      console.error(err);
      return throwError(err);
    });
  }

  // used to update password when user knows old password
  public updatePassword(updatePasswordModel: ChangePasswordRequest): Observable<CommonResponse> {
    return this.accountApi.accountChangePassword(
      updatePasswordModel,
      this.authorization
    ).catch(err => {
      console.error(err);
      return throwError(err);
    });
  }

  public getResetTokenStatus(token: string): Observable<any> {
    return this.accountApi.accountGetPasswordResetTokenStatus(
      token,
      this.authorization
    )
    .catch(err => {
      console.error(err);
      return throwError(err);
    });
  }
}
